export default __webpack_public_path__ + "static/media/elements.422350e2.svg";